import { render, staticRenderFns } from "./app-card.vue?vue&type=template&id=686ab5d2&scoped=true&"
import script from "./app-card.vue?vue&type=script&lang=js&"
export * from "./app-card.vue?vue&type=script&lang=js&"
import style0 from "./app-card.vue?vue&type=style&index=0&id=686ab5d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686ab5d2",
  null
  
)

export default component.exports